export const BALANCE_FETCH_SUCCESS = 'BALANCE_FETCH_SUCCESS';
export const BALANCE_FETCH_ERROR = 'BALANCE_FETCH_ERROR';
export const BALANCE_FETCH_IN_PROGRESS = 'BALANCE_FETCH_IN_PROGRESS';
export const BALANCE_LIST_FETCH_SUCCESS = 'BALANCE_LIST_FETCH_SUCCESS';
export const TRANSFERABLE_BALANCE_LIST_FETCH_SUCCESS = 'TRANSFERABLE_BALANCE_LIST_FETCH_SUCCESS';
export const VESTING_BALANCE_FETCH_SUCCESS = 'VESTING_BALANCE_FETCH_SUCCESS';
export const TOKEN_LIST_FETCH_SUCCESS = 'TOKEN_LIST_FETCH_SUCCESS';
